import React from 'react';

interface CallerProps {
    color?: string;
    width?: number;
    height?: number;
    className?: string;
}

const Caller: React.FC<CallerProps> = ({ 
    color = "#3F3F3F", 
    width = 17, 
    height = 18, 
    className 
}) => {
    return (
        <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width={width} 
            height={height} 
            viewBox="0 0 17 18" 
            fill="none"
            className={className}
        >
            <path 
                fillRule="evenodd" 
                clipRule="evenodd" 
                d="M10.5968 16.3594C8.06878 16.3574 5.64483 15.3523 3.85722 13.5647C2.06961 11.7771 1.06447 9.35314 1.0625 6.82508C1.06202 6.10033 1.32573 5.40025 1.80424 4.85593C2.10449 4.51438 2.47641 4.24885 2.88942 4.07558C3.32733 3.89187 3.79115 4.16907 3.97821 4.60556L4.93429 6.8364C5.07478 7.16421 5.04143 7.54064 4.8455 7.83865L3.91535 9.25336C3.80326 9.42536 3.7375 9.62341 3.72445 9.82829C3.7114 10.0332 3.7515 10.238 3.84087 10.4228C4.51865 11.8074 5.64117 12.9247 7.02891 13.5959C7.21437 13.6842 7.4195 13.7231 7.6244 13.7087C7.8293 13.6944 8.02701 13.6273 8.19835 13.514L9.58244 12.5894C9.88073 12.3902 10.2594 12.3549 10.5894 12.4956L12.8144 13.4444C13.2519 13.631 13.53 14.0954 13.3458 14.5339C13.1725 14.9463 12.9072 15.3178 12.566 15.6177C12.0217 16.0962 11.3216 16.3599 10.5968 16.3594ZM7.61136 12.6284C7.61171 12.6281 7.61206 12.6279 7.61241 12.6277L8.99225 11.7059C9.58884 11.3074 10.3462 11.2368 11.0062 11.5183L13.2312 12.4671C14.0232 12.8049 14.806 13.8012 14.3253 14.9454C14.0903 15.5049 13.7303 16.0088 13.2675 16.4157C12.5291 17.0648 11.5793 17.4226 10.5961 17.4219C7.78657 17.4197 5.09258 16.3027 3.10592 14.316C1.11926 12.3293 0.0021933 9.63547 8.84946e-07 6.82591C-0.000649387 5.84271 0.357093 4.89285 1.00625 4.15442C1.41359 3.69106 1.91815 3.33083 2.47839 3.0958C3.62083 2.61654 4.61606 3.39661 4.95481 4.18702L5.91088 6.41786C6.19186 7.07348 6.12516 7.82634 5.7333 8.42236L4.80493 9.83436C4.79313 9.85281 4.7862 9.87396 4.7848 9.89583C4.78342 9.91761 4.78756 9.93937 4.79685 9.9591C5.36956 11.1271 6.31661 12.0699 7.48715 12.6373C7.50685 12.6464 7.52851 12.6503 7.55014 12.6488C7.57196 12.6473 7.59302 12.6402 7.61136 12.6284Z" 
                fill={color}
            />
            <path 
                fillRule="evenodd" 
                clipRule="evenodd" 
                d="M13.2542 4.13216C11.7016 2.57954 9.96333 1.72405 8.71804 1.65744C8.42505 1.64177 8.20025 1.39156 8.21592 1.09858C8.23159 0.805595 8.4818 0.580789 8.77478 0.59646C10.3765 0.682131 12.3478 1.7231 14.0055 3.38085C15.6633 5.03861 16.7042 7.00983 16.7899 8.61159C16.8056 8.90457 16.5808 9.15478 16.2878 9.17045C15.9948 9.18612 15.7446 8.96132 15.7289 8.66834C15.6623 7.42304 14.8068 5.68477 13.2542 4.13216Z" 
                fill={color}
            />
            <path 
                fillRule="evenodd" 
                clipRule="evenodd" 
                d="M11.0003 6.38606C10.0992 5.48501 9.08323 5.03967 8.37028 5.03906C8.07688 5.03881 7.83924 4.80075 7.83949 4.50735C7.83974 4.21395 8.07779 3.97631 8.37119 3.97656C9.4563 3.97749 10.7264 4.60959 11.7516 5.63476C12.7768 6.65993 13.4089 7.93005 13.4098 9.01516C13.41 9.30856 13.1724 9.54661 12.879 9.54686C12.5856 9.54712 12.3475 9.30947 12.3473 9.01607C12.3467 8.30312 11.9013 7.28711 11.0003 6.38606Z" 
                fill={color}
            />
        </svg>
    );
};

export default Caller;